export enum EHub {
	lomasVerdes = 'Lomas Verdes',
	aleph = 'Aleph',
	miyana = 'Miyana',
	artz = 'Artz',
	monumentoLaMadre = 'Monumento La Madre',
	puertaPolanco = 'Puerta Polanco',
	torreMexicana = 'Torre Mexicana',
}

export interface IHub {
	hub: EHub
	label: string
}
